

import DB from '@/utils/api/DB';
import Vue from 'vue'
import Component from 'vue-class-component';
import Config from '@/utils/config'
import api from '@/utils/api';
@Component
export default class HeaderUser extends Vue{
    info = DB.Get('user.info');
    Model = {...this.info,password1:undefined,password2:undefined};
    showInfo = false;
    isLoading = true;
    config = Config;
    handleClick(name: string) {
        if (name === 'logout') {
            localStorage.clear();
            location.reload();
            this.$router.replace('/login');
        }
        if (name === 'info') {
            this.showInfo = true;
        }
    }

    Close(){
        this.showInfo = false;
        this.info =  DB.Get('user.info');
        this.Model = {...this.info};
    }

    async Save() {
        if(this.Model.password1 || this.Model.password2){
            if(this.Model.password1 != this.Model.password2){
                this.$Message.error('两次密码不一致');
                return;
            }
            this.Model.password = this.Model.password1;
        }
        
        try{
            
            let res = await api.User.Edit(this.Model);
            if (res) {
                this.$Message.success('修改成功');
                this.showInfo = false;
                DB.Set('user.info', res.data);
                this.info =  DB.Get('user.info');
                this.Model = {...this.info};
            }
        }catch(e:any){
            this.$Message.error(e.message);
        }
    }
}
